import { RoleApiModel } from '../../../types/models/role.model';
import { CreateRoleApiRequest } from '../../../types/requests/roles/create-role.request';
import { DeleteRoleApiRequest } from '../../../types/requests/roles/delete-role.request';
import { GetRoleApiRequest } from '../../../types/requests/roles/get-role.request';
import { SearchRolesApiRequest } from '../../../types/requests/roles/search-roles.request';
import { UpdateRoleApiRequest } from '../../../types/requests/roles/update-role.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createRole = (params: CreateRoleApiRequest) => client.post<RoleApiModel>('/roles', params);

export const updateRole = ({ roleId, ...params }: UpdateRoleApiRequest) =>
  client.patch<RoleApiModel>(`/roles/${roleId}`, params);

export const getRole = <T extends RoleApiModel>({ roleId, ...params }: GetRoleApiRequest) =>
  client.get<T>(`/roles/${roleId}`, { params });

export const searchRoles = (params: SearchRolesApiRequest) =>
  client.get<CursorPaginatedApiResponse<RoleApiModel>>(`/roles`, { params });

export const deleteRole = ({ roleId }: DeleteRoleApiRequest) => client.delete<void>(`/roles/${roleId}`);
